import { Accordion, Skeleton, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import { useStepper } from 'widgets/AnketaWidget/lib';

import styles from './UserDataSummary.module.scss';
import { UserDataSummaryTexts } from './UserDataSummary.texts';

export const UserDataSummarySkeleton = () => {
  const { stepsWithMultiStepsOrder: steps } = useStepper();
  const isMobile = useIsMobile();
  return (
    <AdaptiveCard
      className={styles.accordion}
      color="light"
    >
      <Accordion
        defaultIndex={[0]}
        padding={false}
      >
        <Accordion.Item
          title={
            <Typography.Text
              strong
              size={16}
            >
              {UserDataSummaryTexts.caption}
            </Typography.Text>
          }
        >
          <Space
            size={12}
            direction="vertical"
            align="start"
          >
            {steps.map((_, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton key={`step-${i}`}>
                <Space
                  size={8}
                  align="start"
                >
                  <Skeleton.Avatar />
                  <Space
                    direction="vertical"
                    align="start"
                    size={4}
                  >
                    <Skeleton.Paragraph width={isMobile ? 50 : 22} />
                    <Skeleton.Paragraph width={isMobile ? 60 : 30} />
                  </Space>
                </Space>
              </Skeleton>
            ))}
          </Space>
        </Accordion.Item>
      </Accordion>
    </AdaptiveCard>
  );
};
